module.exports = __webpack_public_path__ + "img/bg_m.ea165872.jpg";